import { useEffect, useMemo, useState } from "react";
import { getPreviewSize } from "../helpers";
import {
  DEFAULT_MEDIA_VIDEO_ASPECT_RATIO,
  DESKTOP_ASPECT_RATIO,
} from "pages/media/constants/";

export type PreviewSizes = {
  scene: { width: number; height: number };
};

export const usePreviewResize = (
  mediaAspectRatio: number | undefined = DEFAULT_MEDIA_VIDEO_ASPECT_RATIO
) => {
  const isDesktop = mediaAspectRatio === DESKTOP_ASPECT_RATIO;

  const [windowSize, setWindowSize] = useState({
    width: globalThis.window.innerWidth,
    height: globalThis.window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: globalThis.window.innerWidth,
        height: globalThis.window.innerHeight,
      });
    };

    globalThis.window.addEventListener("resize", handleResize);
    return () => {
      globalThis.window.removeEventListener("resize", handleResize);
    };
  }, []);

  const previewSizes = useMemo<PreviewSizes>(
    () => ({
      scene: getPreviewSize(
        isDesktop,
        windowSize.height,
        windowSize.width,
        mediaAspectRatio
      ),
    }),
    [isDesktop, windowSize.height, windowSize.width, mediaAspectRatio]
  );

  return {
    previewSizes,
  };
};
